window.becomeMember = {
  isShow: sessionStorage.getItem('becomeMember') !== 'false',

  closeBecomeMember() {
    sessionStorage.setItem('becomeMember', false);
    this.isShow = false;
  },
};
